<div class="ion-text-center">
  {{ 'component.order-countdown-timer.countdown-text' | translate }} {{ timeDisplay }}
</div>